export default "__VITE_ASSET__CZFUzyz9__"